export default __webpack_public_path__ + "static/media/new_dashboard_medicaltest_icon.a4b00500.svg";